import { ProbeAction, ProbeCategory } from "../../__generated__/graphql-global-types";
export var MetricType;
(function (MetricType) {
    MetricType["golden_metric"] = "golden_metric";
    MetricType["raw_sfx_query"] = "raw_sfx_query";
})(MetricType || (MetricType = {}));
export var PROBE_CATEGORY_ACTION_MAPPING = new Map([
    [ProbeCategory.signalfx, [ProbeAction.signalfx_query]],
    [ProbeCategory.cloudwatch, [ProbeAction.alb_metrics]]
]);
export var PROBE_CATEGORY_METRIC_MAPPING = new Map([
    [
        ProbeCategory.signalfx,
        [
            "cpu_saturation",
            "mem_saturation",
            "nw_tx_usage",
            "nw_rx_usage",
            "active_webserver_hosts",
            "service_proxy_latency_p99",
            "service_proxy_latency_p90",
            "service_proxy_latency_median",
            "service_proxy_http_2xx",
            "service_proxy_http_4xx",
            "service_proxy_http_5xx"
        ]
    ],
    [
        ProbeCategory.cloudwatch,
        [
            "latency_avg",
            "latency_min",
            "latency_max",
            "latency_p99",
            "latency_p95",
            "latency_p90",
            "latency_p50",
            "latency_p10",
            "request_count_sum",
            "request_count_avg",
            "request_count_min",
            "request_count_max",
            "http_2xx_sum",
            "http_2xx_avg",
            "http_2xx_min",
            "http_2xx_max",
            "http_3xx_sum",
            "http_3xx_avg",
            "http_3xx_min",
            "http_3xx_max",
            "http_4xx_sum",
            "http_4xx_avg",
            "http_4xx_min",
            "http_4xx_max",
            "http_5xx_sum",
            "http_5xx_avg",
            "http_5xx_min",
            "http_5xx_max",
            "target_connection_err_sum",
            "target_connection_err_avg",
            "target_connection_err_min",
            "target_connection_err_max",
            "healthy_host_sum",
            "healthy_host_avg",
            "healthy_host_min",
            "healthy_host_max",
            "unhealthy_host_sum",
            "unhealthy_host_avg",
            "unhealthy_host_min",
            "unhealthy_host_max",
            "http_elb_4xx_sum",
            "http_elb_4xx_avg",
            "http_elb_4xx_min",
            "http_elb_4xx_max",
            "http_elb_5xx_sum",
            "http_elb_5xx_avg",
            "http_elb_5xx_min",
            "http_elb_5xx_max"
        ]
    ]
]);
